(function(){
  function boot(){
    document.querySelectorAll('[data-oe-pairs]').forEach(function(section){
      section.querySelectorAll('[data-pair-row]').forEach(function(row){
        if(row.dataset.ready)return;row.dataset.ready='true';
        var data=row.querySelector('[data-pair-variants]'),form=row.querySelector('form');
        if(!data||!form)return;
        var variants=JSON.parse(data.textContent),selects=Array.from(form.querySelectorAll('[data-pair-option]'));
        var money=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:section.dataset.currency});
        function sync(){
          var values=selects.map(function(select){return select.value;});
          var variant=variants.find(function(item){return item.options.every(function(value,index){return value===values[index];});});
          if(!selects.length)variant=variants[0];
          var id=form.querySelector('[data-pair-variant]'),button=form.querySelector('button[type="submit"]');
          id.disabled=!variant;id.value=variant?variant.id:'';
          button.disabled=!variant||!variant.available;button.textContent=button.disabled?button.dataset.unavailableLabel:button.dataset.addLabel;
          if(!variant)return;
          row.querySelector('[data-pair-price]').textContent=money.format(variant.price/100);
          var compare=row.querySelector('[data-pair-compare]'),saving=row.querySelector('[data-pair-saving]');
          compare.hidden=!(variant.compare_at_price>variant.price);saving.hidden=compare.hidden;
          if(!compare.hidden){compare.textContent=money.format(variant.compare_at_price/100);saving.textContent=section.dataset.saveLabel.replace('__AMOUNT__',money.format((variant.compare_at_price-variant.price)/100));}
          if(variant.featured_image){var image=row.querySelector('.oe-pair-row__image img');if(image){image.removeAttribute('srcset');image.src=variant.featured_image.src;}}
        }
        selects.forEach(function(select){select.addEventListener('change',sync);});
        row.querySelector('details').addEventListener('toggle',function(event){if(event.target.open){section.querySelectorAll('details[open]').forEach(function(details){if(details!==event.target)details.open=false;});}});
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
